import Button from '../button/Button';
import { currencySymbol as resolveCurrencySymbol } from '../../utils/currencyLabel';

interface AssetLoadedBannerProps {
  assetName: string;
  quantity: number;
  quotation: number;
  calculatedAmount: number;
  currencyCode: string;
  onEdit: () => void;
  onClear: () => void;
}

const bannerStyles: React.CSSProperties = {
  backgroundColor: '#E8F0FE',
  borderRadius: '8px',
  border: '1px solid #C5D4F0',
  padding: '12px 16px',
  marginTop: '8px',
};

const gridStyles: React.CSSProperties = {
  display: 'grid',
  gridTemplateColumns: '1fr 1fr',
  gap: '6px 16px',
  fontSize: '13px',
  color: '#333',
  lineHeight: '1.5',
};

const labelStyles: React.CSSProperties = {
  color: '#666',
  fontWeight: 400,
};

const valueStyles: React.CSSProperties = {
  fontWeight: 600,
  textAlign: 'right' as const,
};

const actionsStyles: React.CSSProperties = {
  display: 'flex',
  gap: '8px',
  marginTop: '10px',
  borderTop: '1px solid #C5D4F0',
  paddingTop: '10px',
};

const AssetLoadedBanner = ({
  assetName,
  quantity,
  quotation,
  calculatedAmount,
  currencyCode,
  onEdit,
  onClear,
}: AssetLoadedBannerProps) => {
  const formatAmount = (value: number) =>
    value.toLocaleString('es-AR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

  const currencySymbol = resolveCurrencySymbol(currencyCode);

  return (
    <div style={bannerStyles}>
      <div style={gridStyles}>
        <span style={labelStyles}>Activo</span>
        <span style={valueStyles}>{assetName}</span>

        <span style={labelStyles}>Cantidad</span>
        <span style={valueStyles}>{formatAmount(quantity)}</span>

        <span style={labelStyles}>Cotización</span>
        <span style={valueStyles}>{currencySymbol} {formatAmount(quotation)}</span>

        <span style={labelStyles}>Monto bruto</span>
        <span style={valueStyles}>{currencySymbol} {formatAmount(calculatedAmount)}</span>
      </div>

      <div style={actionsStyles}>
        <Button variant="tertiary" size="sm" onClick={onEdit}>
          Editar activo
        </Button>
        <Button variant="tertiary" size="sm" onClick={onClear}>
          Limpiar
        </Button>
      </div>
    </div>
  );
};

export default AssetLoadedBanner;
